import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Tabs from 'components/Tabs';
import NavLinkWrapper from 'components/Tabs/NavLinkWrapper';
import { Can, ability, updateOrganizationAbility } from 'utils/permissions';

import {
  accountDetail,
  accountContacts,
  accountSubscriptions,
  accountReports,
  accountDetailUrl,
  accountContactsUrl,
  accountSubscriptionsUrl,
  accountReportsUrl,
} from 'constants/routing';

import { changeDocumentTitle } from 'utils/hooks';
import { updateAccount, getAccount } from 'redux/actions/accountActions';
import ClickToEdit from 'components/forms/EditInline';
import { LoadingTitle } from 'components/titles/PageTitle';
import Reports from 'components/Reports/index';
import DetailsTab from './DetailsTab';
import SubscriptionsTab from './SubscriptionsTab';
import ContactsTab from './ContactsTab';


class AccountDetail extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    getAccount: PropTypes.func.isRequired,
    updateAccount: PropTypes.func.isRequired,
    account: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
  };

  constructor() {
    super();
    this.handleEdit = this.handleEdit.bind(this);
  }

  componentDidMount() {
    this.getAccount(this.props.match.params.id);
  }

  componentDidUpdate(preProps) {
    changeDocumentTitle(this.props?.account?.name);
    if (this.props.match.params.id !== preProps.match.params.id) {
      this.getAccount(this.props.match.params.id);
    }
  }


  async getAccount(accountId) {
    await this.props.getAccount(accountId);
    if (this.props.account.loaded) {
      updateOrganizationAbility(ability, this.props.account.organization_permissions);
    }
  }

  handleEdit(accountName) {
    if (accountName) {
      this.props.updateAccount(this.props.account.id, { name: accountName }, true);
    }
  }

  render() {
    const { account } = this.props;
    const isAccountLoaded = parseInt(this.props.account.id, 10) === account.id && account.loaded;
    return (
      <Can I="see" an="Account">
        <Container>
          <Row>
            <Col md={12} className="account-detail">
              {!isAccountLoaded ?
                <LoadingTitle /> :
                <ClickToEdit
                  wrapperClass="page-title"
                  textClass="account__name_custom"
                  value={this.props.account.name}
                  endEditing={this.handleEdit}
                />
              }
              <Card>
                <Tabs>
                  <NavLinkWrapper
                    exact
                    to={accountDetailUrl(this.props.account.id)}
                  >
                    Details
                  </NavLinkWrapper>
                  <NavLinkWrapper
                    to={accountContactsUrl(this.props.account.id)}
                  >
                    Contacts
                  </NavLinkWrapper>
                  <Can I="see" a="Subscription">
                    <NavLinkWrapper
                      to={accountSubscriptionsUrl(this.props.account.id)}
                    >
                      Subscriptions
                    </NavLinkWrapper>
                  </Can>
                  <NavLinkWrapper
                    to={accountReportsUrl(this.props.account.id)}
                  >
                    Analytics
                  </NavLinkWrapper>
                </Tabs>
                <CardBody>
                  <Switch>
                    <Route path={accountDetail} exact component={DetailsTab} />
                    <Route path={accountContacts} component={ContactsTab} />
                    <Route
                      path={accountSubscriptions}
                      render={props => (
                        <Can I="see" a="Subscription">
                          <SubscriptionsTab {...props} />
                        </Can>
                      )}
                    />
                    <Route
                      path={accountReports}
                      render={props => (<Reports
                        {...props}
                        initFilterParams={this.props.account.id ? {
                          account__id: [{ value: this.props.account.id }],
                        } : {}}
                        hideAccountsFilter
                        hideSequencesFilter
                      />)}
                    />
                    <Redirect to="/404" />
                  </Switch>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Can>
    );
  }
}


export default connect(
  state => ({ account: state.account }),
  { updateAccount, getAccount },
)((withNamespaces('common')(AccountDetail)));
